import Vue from 'vue'

import App from './App.vue'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'
import { router, store } from './bootstrap'

window.onload = function() {
  const app = new Vue({
    el: '#app',
    i18n,
    router,
    store,
    vuetify,
    render: (h) => h(App),
  })
}
